<template>
  <!-- Full-viewport placeholder for the moment after login, before the real
       header and side menu mount. It mirrors the app shell (top bar, left nav
       rail, page body) so the wait reads as the app arriving rather than a lone
       block on an empty screen. -->
  <div class="app-shell-skeleton">
    <div class="app-shell-skeleton__header">
      <v-skeleton-loader type="avatar" class="flex-shrink-0 mr-3" />
      <v-skeleton-loader
        type="text"
        width="150"
        class="d-none d-sm-block app-shell-skeleton__brand"
      />
      <v-spacer />
      <v-skeleton-loader type="chip" class="d-none d-sm-block mr-4" />
      <v-skeleton-loader type="avatar" class="flex-shrink-0" />
    </div>

    <div class="app-shell-skeleton__body">
      <div class="app-shell-skeleton__sidebar d-none d-md-block">
        <v-skeleton-loader type="list-item-avatar@9" />
      </div>
      <div class="app-shell-skeleton__content">
        <LayoutPageSkeleton />
      </div>
    </div>
  </div>
</template>

<script>
import LayoutPageSkeleton from "./LayoutPageSkeleton.vue";

export default {
  name: "AppShellSkeleton",
  components: { LayoutPageSkeleton },
};
</script>

<style scoped>
.app-shell-skeleton {
  position: fixed;
  inset: 0;
  z-index: 6;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
}
.theme--dark .app-shell-skeleton {
  background: #121212;
}

.app-shell-skeleton__header {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 64px;
  padding: 0 16px;
  background: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.theme--dark .app-shell-skeleton__header {
  background: #1e1e1e;
  border-bottom-color: rgba(255, 255, 255, 0.12);
}

.app-shell-skeleton__body {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
}

.app-shell-skeleton__sidebar {
  width: 256px;
  flex-shrink: 0;
  padding: 12px 8px;
  background: #ffffff;
  border-right: 1px solid rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.theme--dark .app-shell-skeleton__sidebar {
  background: #1e1e1e;
  border-right-color: rgba(255, 255, 255, 0.12);
}

.app-shell-skeleton__content {
  flex: 1 1 auto;
  min-width: 0;
  padding: 16px;
  overflow: hidden;
}

/* The avatar loader is square by default; round it so it reads as the toolbar
   avatar and nav-icon it stands in for. */
.app-shell-skeleton__header ::v-deep .v-skeleton-loader__avatar {
  height: 36px;
  width: 36px;
}
</style>
